import classNames from "classnames";

import styles from "./PulseIcon.module.scss";

interface PulseIconProps {
  status: "up" | "down";
  className?: string;
}

export const PulseIcon = ({status, className}: PulseIconProps) => (
  <svg
    className={classNames(styles.pulseIcon, styles[status], className)}
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="11.5" cy="11" r="9" fill="currentColor" />
    <circle opacity="0.25" cx="11.5" cy="11" r="8" fill="currentColor" />
    <circle opacity="0.4" cx="11.5" cy="11" r="7" fill="currentColor" />
    <circle cx="11.5" cy="11" r="6" fill="currentColor" />
  </svg>
);
